import { Suspense, useState } from "react";
import { apiAccountStatusGet } from "../api/account/status/get";
import { Navigate, Outlet } from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import { SessionProvider } from "../providers/SessionProvider";

export const ProtectedRoute = () => {
  const [isAuthorized, setIsAuthorized] = useState<boolean>();

  useAsyncEffect(async() => {
    try {
      const response = await apiAccountStatusGet();
      if (response) {
        setIsAuthorized(response.status === 200);
      }
    }
    catch (error) {
      setIsAuthorized(false);
    }
  }, []);

  if (isAuthorized === false) {
    return (
      <Navigate to={"/login"} replace />
    );
  }

  return (
    <Suspense fallback={<div>Authenticating...</div>}>
      <SessionProvider>
        <Outlet />
      </SessionProvider>
    </Suspense>
  );
}
